import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
export var useStyles = makeStyles({
    imageButton: {
        width: '200px',
    },
});
/**
 * SmartCheckの使用するボタン画像コンポーネント
 * @param props
 */
export var SmartCheckUseButton = function (props) {
    var classes = useStyles();
    if (props.loading) {
        return React.createElement(CircularProgress, null);
    }
    if (props.imageUrl) {
        // クーポンマスタで画像が登録されている場合は、その画像を出す
        return (React.createElement("input", { type: "image", src: props.imageUrl, className: classes.imageButton, alt: "SmartCheck\u753B\u50CF", disabled: props.disabled || props.loading }));
    }
    else {
        // 登録されていない場合は、デフォルトの画像を出す
        return (React.createElement("input", { type: "image", src: "/smartCheck-use-button-default.gif", className: classes.imageButton, alt: "SmartCheck\u753B\u50CF", disabled: props.disabled || props.loading }));
    }
};
//# sourceMappingURL=SmartCheckUseButton.js.map